import React, { useEffect, useState } from 'react';
import './styles.css';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { Button, Spinner } from "react-bootstrap"
import firebase from 'firebase';
import * as crud from "../operations"
import { useToasts } from 'react-toast-notifications';
import Lightbox from "react-awesome-lightbox";

const storage = firebase.storage();
const App = (props) => {
    const [isOpen, setImage] = useState(false);
    const { addToast } = useToasts();
    const [uploading, setUploading] = useState(false)
    const [selectedFiles, setSelectedFiles] = useState([]);
    useEffect(() => {
        if (Array.isArray(props.files)) {
            setSelectedFiles(props.files);
        }
    }, [props.files])
    const handleImageChange = async (e) => {
        setUploading(true)
        const images = []

        for (const image of e.target.files) {
            if (image == null)
                return;
            const ref = storage.ref(`/campaign/${props.campaign.uid}/planograms/${image.name}`)
            await ref.put(image)
            const url = await ref.getDownloadURL()
            images.push(url)

        }
        const planograms = selectedFiles.concat(images)
        crud.updateSoftClient({ uid: props.campaign.uid, planograms: planograms }).then(() => {
            addToast(process.env["REACT_APP_CREATE"], { appearance: 'success' });
            setSelectedFiles(planograms);
            setUploading(false)
        }).catch(() => {
            addToast(process.env["REACT_APP_NO_UPDATE"], { appearance: 'error' });

            setUploading(false)

        })
    };

    const renderPhotos = (source, event) => {
        return source.map((photo) => {
            return <img src={photo} alt="" key={photo} className="img-planogram pointer-hover" onClick={() => event(photo)}/>;
        });
    };
    function openAttachment() {
        document.getElementById('file').click();
    }
    return (

        <div className="card p-4 rounded shadow-sm" style={{ minHeight: "600px" }}>
            {isOpen && <Lightbox image={isOpen} onClose={() => setImage(null)} />}

            <input type="file" id="file" multiple onChange={handleImageChange} />

            {uploading ? <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
            </Spinner> : selectedFiles.length ?
                <div>
                    <div className="col-6 w-100 justify-content-end d-flex ">
                        <h1>
                            PLANOGRAM
                        </h1>
                    </div>
                    <Button
                        variant="success"
                        onClick={openAttachment}
                    >
                        <span className="svg-icon svg-icon svg-icon-white d-inline my-2">
                            <SVG
                                src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                            ></SVG>

                        </span>Add More Planograms
                    </Button>
                    <div className="result">{renderPhotos(selectedFiles, (image) => setImage(image))}</div>
                </div> :
                <>
                    <div className="card p-4 rounded" style={{ minHeight: "600px" }}>
                        <div className="col-6 w-100 justify-content-end d-flex ">
                            <h3>
                                PLANOGRAM
                            </h3>
                        </div>
                        <div className="col-md-12 d-flex w-100 justify-content-center text-center">
                            <div>
                                <SVG src={toAbsoluteUrl("/media/svg/undraw/undraw_Sorting_thoughts_re_fgli.svg")} style={{ display: "block", width: "60%", margin: "auto" }} />
                                <p>
                                    <strong>Don't</strong> have any <b>Planogram</b>
                                </p>
                    
                            </div>
                        </div>

                    </div>
                </>}
        </div>
    );
};

export default App;